import React, { useContext, useEffect, useState } from "react"
import "./LoginFormModalStyle.scss"
import { loginFormModalTextContent } from "./constant"
import CustomModal from "../Common_UI_Kit/CustomModal"
import CustomButton from "../Common_UI_Kit/CustomButton"
import CustomInput from "../Common_UI_Kit/CustomInput"
import { useNavigate } from "react-router-dom"
import { LoginContext } from "context/context"
import { ProtectRoutesContext } from "context/ProtectRoutesContext"

const PasswordEntryModal = () => {
  const navigate = useNavigate()
  const { openPasswordEntryModal, setOpenPasswordEntryModal } = useContext(LoginContext)
  const { login } = useContext(ProtectRoutesContext)

  const [password, setPassword] = useState("")
  const [formError, setFormError] = useState(null)

  useEffect(() => {
    let timeout = null
    if (openPasswordEntryModal) {
      timeout = setTimeout(() => {
        handleInputFocus()
      }, 100)
    }
    return () => clearTimeout(timeout)
  }, [openPasswordEntryModal])

  const handleInputFocus = () => {
    const usernameInput = document.getElementById('passwordField')
    if (usernameInput) {
      usernameInput.focus()
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (login(password)) {
      navigate("/slot-games-list") // Redirect to a protected page after authentication
      setOpenPasswordEntryModal(false)
    } else {
      setFormError("Incorrect password!")
    }
  }

  const handleChange = (key, value) => {
    if (key === 'Password') {
      setFormError(value ? null : 'Please Enter Password.')
      setPassword(value)
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit(event);
    }
  }

  return (
    <>
      <CustomModal
        isOpen={openPasswordEntryModal}
        onClose={() => setOpenPasswordEntryModal(false)}
        title={loginFormModalTextContent.ModalTitleText}
      >
        <div className="auth-form-wrap" onKeyDown={handleKeyDown} tabIndex={0}>
          <div className="auth-form-box">
            <CustomInput
              id='passwordField'
              fieldType="passwordField"
              type="text"
              label="Password"
              placeholder="Enter Your Password"
              value={password}
              onChange={(e) => handleChange('Password', e.target.value)}
            />
          </div>
          <div className="login-form-error">{formError}</div>

          <div className="btn-box">
            <CustomButton buttonType="secondary" type="submit" label={loginFormModalTextContent.btnText} onClick={handleSubmit} />
          </div>
        </div>
      </CustomModal>
    </>
  )
}

export default PasswordEntryModal
